
/**
 * @name InternalTickets.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\InternalTickets.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
import Swal from 'sweetalert2';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null, toggleNotificationState = null, getCourtesyIsUsed = null, getInternalTicketCategoryType = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;
        toggleNotificationState = utils.toggleNotificationState;
        getCourtesyIsUsed = utils.getCourtesyIsUsed;
        getInternalTicketCategoryType = utils.getInternalTicketCategoryType;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        //if (location.pathname !== utils.getBaseDir() + 'contratos/transferencia')
        //    return;

        new ContractsAndPatientTransfer(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class ContractsAndPatientTransfer
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.onloadList = onloadList;
        this.init();
    }

    init() {
        let self = this;
        $(document).on('change', '#patient_transfer_origin_branch', this.onChangeBranch.bind(this));
        $(document).on('click', '.js-patient-transfer-clear-field', function() {
            $('#patient_transfer_contract').val(null).trigger('change');
            $("#patient_transfer_contract_id").val('');
            $("#patient_transfer_customer_id").val('');
        });

        $(document).on('click', '.js-open-patient-transfer-modal', function() {
            let patientInfo = $(this).data('patient-info');
            console.log('patientInfo', patientInfo);
            $('#patient_transfer_origin_branch').val(patientInfo.FILIAL_ID);
            $('#patient_transfer_contract').prop('disabled', false);
            $('#patient_transfer_destination_branch').prop('disabled', false);
            $('#patient_transfer_customer_id').val(patientInfo.ID);
            $('#patient_transfer_contract').html(`<option value='${patientInfo.ID}' selected>${patientInfo.NOME_COMPLETO}</option>`);
            $('#patient_transfer_contract').val(patientInfo.ID).trigger('select2:select');
            $("#patient_transfer_contract_id").val(-1);
        });

        $('#patient_transfer_contract').select2({
            placeholder: "Busque por nome ou código do contrato",
            theme: 'bootstrap-5',
            dropdownParent: $(".js-patient-transfer-contract-container"),
            minimumInputLength: 3,
            ajax: {
                url: getBaseDir() + 'api/v1/patient/contract/search',
                delay: 1000,
                data: function(params) {
                    var query = {
                        search: params.term,
                        branchId: self.selectedBranch || -1,
                        page: params.page || 1
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function(data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function(k, v) {
                        results.push({
                            id: v.ID,
                            text: `${v.ID} - ${v.CLIENTE_NOME}`,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });
        
        $('#patient_transfer_contract').on('select2:select', function(e) {
            console.log('e.params.data', e.params.data);
            $("#patient_transfer_contract_id").val(e.params.data.info.ID);
            $("#patient_transfer_customer_id").val(e.params.data.info.CLIENTE_ID);
        });

        $('.js-contracts-transfer-form').on('submit', this.onSubmit.bind(this));

        $('#patient_transfer_contract').prop('disabled', true);
        $('#patient_transfer_destination_branch').prop('disabled', true);
    }

    onChangeBranch(e)
    {
        this.selectedBranch = e.target.value;
        $('#patient_transfer_contract').val(null).trigger('change');

        if (this.selectedBranch == '') {
            $('#patient_transfer_contract').prop('disabled', true);
            $('#patient_transfer_destination_branch').prop('disabled', true);
            return;
        }
        $('#patient_transfer_contract').prop('disabled', false);
        $('#patient_transfer_destination_branch').prop('disabled', false);
    }

    onSubmit(e) {
        e.preventDefault();
        let self = this;

        if ($('#patient_transfer_origin_branch').val() == '') {
            Swal.fire({
                title: 'Erro',
                text: 'Selecione uma filial de origem',
                icon: 'error'
            });
            return;
        }
        if ($('#patient_transfer_contract').val() == '') {
            Swal.fire({
                title: 'Erro',
                text: 'Selecione um contrato',
                icon: 'error'
            });
            return;
        }
        if ($('#patient_transfer_destination_branch').val() == '') {
            Swal.fire({
                title: 'Erro',
                text: 'Selecione a filial de destino',
                icon: 'error'
            });
            return;
        }
        if ($('#patient_transfer_origin_branch').val() == $('#patient_transfer_destination_branch').val()) {
            Swal.fire({
                title: 'Erro',
                text: 'A filial de destino não pode ser a mesma que a de origem',
                icon: 'error'
            });
            return;
        }

        Swal.fire({
            title: 'Confirmação',
            text: `Você deseja transferir o contrato ${$('#patient_transfer_contract').val()} para a filial ${getBranchNameFromId($('#patient_transfer_destination_branch').val())}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    originBranchId: $("#patient_transfer_origin_branch").val(),
                    destinationBranchId: $('#patient_transfer_destination_branch').val(),
                    customerId: $('#patient_transfer_customer_id').val(),
                }
                //return console.log('data', data);
                apiCall({
                    method: 'POST',
                    endpoint: 'api/v1/patient/contract/transfer_patient',
                    data: data,
                    successCallback: function(response) {
                        if (!response.error) {
                            Swal.fire({
                                title: 'Sucesso',
                                text: 'Contrato transferido com sucesso',
                                icon: 'success'
                            }).then(() => {
                                $('.js-contracts-transfer-form').trigger('reset');
                                $('#patient_transfer_contract').val(null).trigger('change');
                                $("#patient_transfer_contract_id").val('');
                                $("#patient_transfer_customer_id").val('');

                                if ($('#js-patients-registrations-search-input').length > 0) {
                                    $('#js-patients-registrations-search-input').trigger('change');
                                }
                            });
                        } else {
                            Swal.fire({
                                title: 'Erro',
                                text: 'Erro ao transferir contrato',
                                icon: 'error'
                            });
                        }
                    },
                    errorCallback: function() {
                        Swal.fire({
                            title: 'Erro',
                            text: 'Erro ao transferir contrato',
                            icon: 'error'
                        });
                    }
                });
            }
        });
    }
}